declare global {
  interface Window {
    webkitRequestAnimationFrame?(cb: FrameRequestCallback): number;
    mozRequestAnimationFrame?(cb: FrameRequestCallback): number;
    webkitCancelAnimationFrame?(handle: number): void;
    mozCancelAnimationFrame?(handle: number): void;
  }
}

export const rAF: (fn: (time: number) => void) => number = ((): ((fn: (time: number) => void) => number) => {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    ((callback: (time: number) => void) => window.setTimeout(callback, 1000 / 60))
  );
})();

export const cAF: (requestId: number) => void = (function () {
  return (
    window.cancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    function (id: number) {
      window.clearTimeout(id);
    }
  );
})();
